<template>
  <div>
    <!-- begin login-cover -->
    <div class="login-cover">
      <div
        class="login-cover-image"
        v-bind:style="{
          backgroundImage:
            'url(' + require('@/assets/images/login-bg.png') + ')'
        }"
      ></div>
      <div class="login-cover-bg"></div>
    </div>
    <!-- end login-cover -->

    <!-- begin login -->
    <div class="login login-v2" data-pageload-addclass="animated fadeIn">
      <!-- begin brand -->
      <div class="login-header">
        <div class="brand">
          <span
            ><img
              src="@/assets/images/bonacube-logo-white.png"
              style="max-width: 300px"
          /></span>
        </div>
      </div>
      <!-- end brand -->
      <!-- begin login-content -->
      <div class="login-content">
        <form @submit.prevent="handleSubmit" class="margin-bottom-0">
          <div class="form-group m-b-20">
            <input
              v-model="password"
              type="password"
              class="form-control form-control-lg"
              placeholder="New password"
              required
            />
            <input
              v-model="passwordConfirmation"
              type="password"
              class="form-control form-control-lg"
              placeholder="New password again"
              required
            />
            <div class="my-2">Slam in your new password</div>
            <button
              :disabled="!submitEnabled"
              type="submit"
              class="btn btn-success btn-block btn-lg"
            >
              Set password
            </button>
          </div>
          <div v-if="messages.errors && messages.errors.length > 0">
            <b-list-group>
              <b-list-group-item
                variant="warning"
                v-for="(message, messageKey) in messages.errors"
                :key="messageKey"
              >
                {{ message }}
              </b-list-group-item>
            </b-list-group>
          </div>

          <div v-if="messages.success && messages.success.length > 0">
            <b-list-group>
              <b-list-group-item
                variant="success"
                v-for="(message, messageKey) in messages.success"
                :key="messageKey"
              >
                {{ message }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </form>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end login -->
  </div>
</template>

<script>
import PageOptions from '../config/PageOptions.vue'
export default {
  created() {
    PageOptions.pageEmpty = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  data: () => ({
    password: '',
    passwordConfirmation: '',
    submitDisabled: null,
    messages: {
      success: [],
      errors: []
    }
  }),
  computed: {
    validPassword() {
      return this.password.length >= 8
    },
    validConfirmation() {
      return (
        (this.password.length || this.passwordConfirmation.length) &&
        this.passwordConfirmation === this.password
      )
    },
    submitEnabled() {
      return this.validPassword && this.validConfirmation
    }
  },
  methods: {
    handleSubmit() {
      this.submitDisabled = true
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password: this.password,
          token: this.$route.query.t
        })
      }
      fetch(process.env.VUE_APP_API_URL + '/auth/reset', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.messages.success.push(data.message)
            this.messages.success.push('Redirecting to login... Please wait...')
            setTimeout(() => {
              this.$router.push('/login')
            }, 3000)
          } else {
            this.messages.errors.push(data.message)
            this.submitDisabled = false
          }
        })
    }
  }
}
</script>
